/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./accountMgmtSettings.vue?vue&type=template&id=2f91e415&scoped=true"
import script from "./accountMgmtSettings.vue?vue&type=script&lang=js"
export * from "./accountMgmtSettings.vue?vue&type=script&lang=js"
import style0 from "./accountMgmtSettings.vue?vue&type=style&index=0&id=2f91e415&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f91e415",
  null
  
)

export default component.exports